<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :items-per-page-options="[10, 25, 50, 100]"
    :search="search"
    v-bind="pagingOptions"
    :hide-default-footer="hideFooter"
    class="elevation-1"
  >
    <template v-slot:item.estimatedStart="{ item }">
      {{ item.estimatedStart | formatDate }}
    </template>
    <template v-slot:item.itineraryRef="{ item }">
      <reference-label
        v-model="item.itineraryRef"
        :itinerary-id="item.itineraryId"
      ></reference-label>
    </template>
    <template v-slot:item.project="{ item }">
      {{
        item.taskType == "itinerary"
          ? item.project.split("/").pop()
          : item.project
      }}
    </template>
    <template v-slot:item.itineraryStartDate="{ item }">{{
      item.itineraryStartDate | formatDate
    }}</template>
    <template v-slot:item.itineraryEndDate="{ item }">{{
      item.itineraryEndDate | formatDate
    }}</template>
    <template v-slot:item.updatedAt="{ item }">{{
      item.updatedAt | formatDate
    }}</template>

    <template v-slot:item.actions="{ item }">
      <default-list-actions
        :item="item"
        :hide-view="true"
        @deleteItem="$emit('delete', $event)"
        @editItem="$emit('edit', $event)"
      ></default-list-actions>
    </template>
  </v-data-table>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";
import StatusLabel from "../../shared/labels/StatusLabel";
import SupplierLabel from "../../shared/labels/SupplierLabel";
import AgentLabel from "../../shared/labels/AgentLabel";
import ReferenceLabel from "../../shared/labels/ReferenceLabel";
import ClientLabel from "../../shared/labels/ClientLabel";
export default {
  name: "tasks-list-table",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false,
    },
  },

  components: {
    DefaultListActions,
    StatusLabel,
    SupplierLabel,
    AgentLabel,
    ReferenceLabel,
    ClientLabel,
  },

  data() {
    return {
      pagingOptions,
    };
  },

  methods: {
    deleteItem(payload) {
      this.$emit("delete", payload);
    },
    editItem(payload) {
      this.$emit("edit", payload);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/task-tracker/TasksListTable.vue